import { atom } from "jotai";
import { allServicesAtom } from "./atoms";

export const servicesDropdownOptionsAtom = atom((get) => {
    const allServices = get(allServicesAtom);
    return ["All", ...allServices];
});
